import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';
import { BusinessVerificationApiErrorsArchiveAllForVendor } from './vive-api-models';

class BusinessVerificationApiErrorsService extends ViveApiBaseService {
  public async archiveAllForVendor(params: {
    options?: ViveApiRequestOptions;
    data: BusinessVerificationApiErrorsArchiveAllForVendor;
  }): Promise<void> {
    const { options, data } = params;
    await this.sendPost<void>({
      apiEndpoint: 'business-verification-api-errors/archive-all-for-vendor',
      options,
      data
    });
  }
}

export const businessVerificationApiErrorsService =
  new BusinessVerificationApiErrorsService();
